import Vue from 'vue'
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'module',
            modules: [],
            module: {},
            actions: {},
            action: {},
            action_group: {},
            properties: {},
            entities: {},
            entity_properties: {},
            entity_property_values: [],
            accessModules: [],
            propertiesValuesLog: []
        },
        actions: {
            init({ dispatch }) {
                dispatch('getModules');
            },

            getAPKLink({ rootState }, type) {
                return helpers.http.get({context: this, rootState}, '/apk/' + type);
            },

            //получение списка модулей
            getAccessModules({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/user/access/modules').then(r => {
                    Vue.set(state, 'accessModules', r);
                    return r;
                });
            },

            //получение списка модулей
            getModules({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/module').then(r => {
                    Vue.set(state, 'modules', r);
                    return r;
                });
            },

            //получение модуля
            getModule({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/module/' + rootState.route.params.code).then(r => {
                    Vue.set(state, 'module', r);
                    return r;
                });
            },

            //получение действий модуля
            getModuleActions({ state, rootState }, code) {
                return helpers.http.get({context: this, rootState}, '/module/' + code + '/actions').then(r => {
                    Vue.set(state, 'actions', r);
                    return r;
                });
            },

            //получение групп пользователей, которым разрешено переданное действие
            getModuleActionGroup({ state, rootState }, code) {
                return helpers.http.get({context: this, rootState}, '/module/' + code + '/actions/' + rootState.route.params.action_code).then(r => {
                    Vue.set(state, 'action_group', r);
                    return r;
                });
            },

            //разрашаем группе пользователей выполнять действие
            postUserGroupToAction({ dispatch, rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/action', data).then(r => {
                    dispatch('getModuleActionGroup', data.module_code);
                    return r;
                });
            },

            postUserGroupsToAction({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/actions', data).then(r => {
                    //dispatch('getModuleActionGroup', data.module_code);
                    return r;
                });
            },

            //запрещаем группе пользователей выполнять действие
            removeUserGroupFromAction({ dispatch, rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/action', data)
                    .then(() => dispatch('getModuleActionGroup', data.module_code));
            },

            getModulePropertiesValuesLog({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, `/log/property-values/${data.code}`, { params: data }).then(r => {
                    Vue.set(state, 'propertiesValuesLog', r);
                    return r;
                });  
            },

            //получаем свойства модуля (настройки модуля)
            getModuleProperties({ state, rootState }, data) {
                let moduleCode = rootState.route.params.code || data.module;
                return helpers.http.get({context: this, rootState}, '/module/' + moduleCode + '/props').then(r => {
                    Vue.set(state, 'properties', r);
                    return r;
                });            
            },

            //Добавляет/Обновляет значение настройки (свойтсва) модуля
            setModulePropertiesValue({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/module/' + data.module + '/props-values', data);
            },


            //Удаляет значение настройки (свойтсва) модуля
            removeModulePropertyValue({ rootState }, prop_code) {
                return helpers.http.delete({context: this, rootState}, '/module/' + rootState.route.params.code + '/props/' + prop_code);
            },

            //Добавляет/Обновляет значение настройки (свойтсва) модуля
            setModulePropertyValue({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/module/' + data.module_name + '/props', data);
            },

            //возвращает одно значение для указанного свойства
            getOneModulePropertyValue({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/module/' + data.module_name + '/props/' + data.prop_name + '/one');
            },

            //получение все сущностей, которые есть в модуле
            getModuleEntities({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/module/' + rootState.route.params.code + '/entity').then(r => {
                    Vue.set(state, 'entities', r);
                    return r;
                });
            },

            //получение кастомных свйоств, которые есть в модуле у конкретной сущности
            getModuleEntitiesProperties({ state, rootState }, data) {
                let module_code = rootState.route.params.code,
                entity_code = rootState.route.params.entity_code,
                active    = '',
                entity_id = '';

                if (data && data.entity_code) entity_code = data.entity_code;
                if (data && data.module_code) module_code = data.module_code;
                if (data && data.entity_id)   entity_id   = '/' + data.entity_id;
                if (data) active = '?active=1';

                return helpers.http.get({context: this, rootState}, '/properties/' + module_code + '/entity/' + entity_code + entity_id + active).then(r => {
                    Vue.set(state, 'entity_properties', r);
                    return r;
                });
            },

            //обновление настроек кастомного свойства в конкретном модуле и сущности
            putModuleEntitiesProperty({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/properties', data);
            },
            
            //создание нового кастомного свойства
            postModuleEntitiesProperty({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/properties', data);
            },

            //удаление кастомного свойства
            removeModuleEntitiesProperty({ dispatch, rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/properties/' + id)
                    .then(() => dispatch('getModuleEntitiesProperties'));
            },

            //добавление/изменение вариантов выбора для свойств типа select, radio, checkbox
            updateModuleEntitiesPropertyValues({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/properties/' + data.property_id +'/choicesarr', data);
            },

            //получаение вариантов выбора для свойства
            getModuleEntitiesPropertyValues({ state, rootState }, property_id) {
                return helpers.http.post({context: this, rootState}, '/properties/' + property_id +'/choices')
                    .then(r => Vue.set(state, 'entity_property_values', r))
            },
            //удаление одного варианта выбора свойства
            removeModuleEntitiesPropertyValues({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/properties/' + data.property_id +'/choices/' + data.id);
            },

            setModuleEntitiesPropertyValues({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/properties/values/update', data);
            },

            removeModuleEntitiesPropertyValuesFile({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/properties/values/files', data);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/module/store.js